// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import analytics from './analytics'
import auth from './auth'
import imageModule from './imageModule'
import layout from './layout'
import navbar from './navbar'
import dashboard from './dashboard'
import helpCenter from './helpCenter'

const rootReducer = combineReducers({
  analytics,
  auth,
  dashboard,
  imageModule,
  layout,
  navbar,
  helpCenter
})

export default rootReducer
